module.exports = __webpack_public_path__ + "assets/nabuco-ico-pickdate.51f2fd5b.svg";